import Tippy from '@tippyjs/react';

import { formatDate } from 'lib/helpers/dateUtils';

import Icon from 'components/shared/Icon/Icon';

const GoLiveDateCell = ({ value }) => {
  if (!value?.soft_go_live_date && !value?.hard_go_live_date) {
    return 'N/A';
  }
  const rawDate = value?.hard_go_live_date ?? value?.soft_go_live_date;
  const formattedDate = formatDate(rawDate, null);

  const today = new Date();
  const goLiveDate = new Date(rawDate);
  const diffTime = goLiveDate - today;
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  const iconColor = diffDays <= 7 ? 'danger' : diffDays > 7 && diffDays <= 14 ? 'warning' : null;
  const iconContent = diffDays > 0 ? `${diffDays} days to go` : 'Go live date passed';
  const icon = diffDays <= 14 ? 'danger-filled' : null;

  return (
    <div className="flex items-center gap-2">
      <div>{formattedDate}</div>
      {icon && (
        <Tippy className="tippy-dark" content={iconContent} placement="top">
          <div className="flex items-center">
            <Icon icon={icon} color={iconColor} />
          </div>
        </Tippy>
      )}
    </div>
  );
};
export default GoLiveDateCell;
